import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { handleScrollTo } from '../shared/scroll-to'

class HomeSidebarController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.scrollToOpenMenuItem();
  }
  addEventListeners() {
    super.addEventListeners();
  }
  removeEventListeners() {
    super.removeEventListeners();
  }
  
  // ### OWN
  scrollToOpenMenuItem() {
    const container = document.querySelector(this.getContainerSelector());
    const open = container ? container.querySelector("li.active") : null;
    if (open) {
      trace("open element to scroll to:", open)
      const rectCont = container.getBoundingClientRect();
      const rectEl = open.getBoundingClientRect();
      const top = rectEl.top - rectCont.top;
      container.scroll({ left: 0, top });
    }
  }

}

export default HomeSidebarController;